import cookie from '@/utils/cookie.js';
import keys from '@/utils/keys.js';

// 所有对状态的更改都通过mutations处理，其类似于自定义事件 $emit('xxxx')
export default {
  // 切换模式
  changeMode(state, mode) {
    state.mode = mode;
  },
  //切换上顶部Nav
  changeTabs(state,active){
      state.active=active
  },
  // 切换语言
  changeLanguage(state, locale) {
    state.locale = locale;
  },
  // 设置登录状态
  setLoginStatus(state, status) {
    state.isLogin = status;
    if(status === false) {
      cookie.delete('');
    }
  },
  setRedirect(state, url) {
    state.redirect = url;
  },
  sendMessage(state, payload) {
    if(typeof payload === 'object') {
      state.message = payload.message;
      if (payload.type !== undefined) {
        state.messageType = payload.type;
      }else{
        state.messageType = 'success';
      }
    }else{
      state.message = payload;
    }
  },
  // 设置站点标题
  setSiteTitle(state, subtitle) {
    let title = process.env.VUE_APP_TITLE;
    if(subtitle) {
      title = subtitle + ' - ' + title;
    }
    document.title = title;
  },
  setIndicatorStatus(state, statue) {
    state.showIndicator = statue;
  },
  showIndicatorWindow(state, payload) {
    if(!payload.url && payload.url === '') return;
    state.showIndicator = true;
    state.taskProcessUrl = payload.url;
    state.taskProcessCallback = payload.callback || function () {};
  },
  setPageUrl(state, url) {
    state.pageUrl = url;
  },
  setUserSettings(state, obj) {
    let {mode, locale} = obj;
    localStorage.setItem(
      keys.userSettings,
      JSON.stringify({
        mode,
        locale
      })
    );
  },
  getUserSettings(state) {
    let userSettings = localStorage.getItem(keys.userSettings);
    if(userSettings !== null) {
      userSettings = JSON.parse(userSettings);
      for (let key in userSettings) {
        state[key] = userSettings[key];
      }
    }
  },
};
